import LottiePlayer from 'components/global/LottiePlayer';

const LengthUnitLotties = ({ unit }) => {
	const units = {
		length: 'length',
		width: 'width',
		height: 'height'
	};

	return <LottiePlayer name={units[unit]} width="60px" height="60px" />;
};

export default LengthUnitLotties;
